import cn from "classnames";

import style from "./style.module.css";
import AssessmentTemplateCardHeader from "./AssessmentTemplateCardHeader";

export interface AssessmentTemplateCardProps {
  description: string;
  className?: string;
  containerStyle?: React.CSSProperties;
  children?: React.ReactNode;
  compositeScore: number;
  compositeTitle: string;
  icon: string | null;
  isSubComposite?: boolean;
  hasSubComposite?: boolean;
}

export default function AssessmentTemplateCard({
  description,
  className,
  containerStyle,
  compositeTitle,
  compositeScore,
  icon,
  isSubComposite = false,
  hasSubComposite = false,
  children,
}: AssessmentTemplateCardProps) {
  return (
    <section className={cn(style.card, className)} style={containerStyle}>
      <AssessmentTemplateCardHeader compositeTitle={compositeTitle} compositeScore={compositeScore} icon={icon} />
      <div className={isSubComposite ? style.subCompositeWrapper : undefined}>
        {description && <p className={style.description}>{description}</p>}
        {children && <div className={hasSubComposite ? style.subCompositeContent : style.content}>{children}</div>}
      </div>
      {isSubComposite && <div className={style.fullBleedDivider} aria-hidden="true" />}
    </section>
  );
}
